// src/config/config.js
const API_BASE_URL = 'https://dc28.job-bid.ca/server/api/';

export { API_BASE_URL };
